import React from 'react';
import { Link } from 'react-router-dom';

/**
 * The one breadcrumb trail. `items` = [{ label, to?, onClick?, testId? }]; `to` is a router
 * location (string or { pathname, state }); `onClick` makes the crumb a button instead (for a
 * step that lives in component state rather than a route). The last item is the current page
 * (no link, aria-current). Replaces the per-module "← Back to …" links and ad-hoc crumb divs so
 * every secondary page says where it sits the same way.
 */
function Breadcrumbs({ items, className, testId = 'breadcrumbs' }) {
  const list = (items || []).filter(Boolean);
  if (!list.length) return null;
  return (
    <nav aria-label='Breadcrumb' className={`sg-breadcrumb${className ? ` ${className}` : ''}`} data-testid={testId}>
      <ol>
        {list.map((item, i) => {
          const last = i === list.length - 1;
          let node = <span>{item.label}</span>;
          if (!last && item.to) node = <Link to={item.to} data-testid={item.testId}>{item.label}</Link>;
          else if (!last && item.onClick) node = <button type='button' className='sg-breadcrumb__btn' onClick={item.onClick} data-testid={item.testId}>{item.label}</button>;
          return (
            <li key={`${item.label}-${i}`} aria-current={last ? 'page' : undefined}>
              {node}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
